import { Expose, Type } from "class-transformer";
import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";
import { SelectItem } from "@/models/api/SelectItem";
import { KSEF_INTEGRATION_TYPE_ENUM } from "@/static/ksefIntegrationTypeEnum";

export class ExportBetweenOfficeSetting {
  @Expose()
  @IsBoolean()
  enableOrderExport!: boolean;

  @Expose()
  @IsBoolean()
  enableOrderExportPKP!: boolean;
}

export class CostDocumentPairOffice {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsNumber()
  recordStampId!: number;

  @Expose()
  @IsString()
  officeName!: string;

  @Expose()
  @IsString()
  officeId!: string;
}

export class ContractorExportSetting {
  @Expose()
  @IsString()
  @IsOptional()
  integrationId!: null | string;

  @Expose()
  @IsBoolean()
  exportOrder!: boolean;

  @Expose()
  @IsBoolean()
  exportOrderAutomaticAfterGenerateInvoice!: boolean;

  @Expose()
  @IsBoolean()
  exportCostDocument!: boolean;

  @Expose()
  @IsBoolean()
  exportCostDocumentOther!: boolean;
}

export class CostDocumentPairSetting {
  @Expose()
  @Type(() => CostDocumentPairOffice)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  pairWithClone!: Array<CostDocumentPairOffice>;

  @Expose()
  @Type(() => CostDocumentPairOffice)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  pairWithOriginal!: Array<CostDocumentPairOffice>;

  constructor() {
    this.pairWithClone = new Array<CostDocumentPairOffice>();
    this.pairWithOriginal = new Array<CostDocumentPairOffice>();
  }
}

export class ApiIntegration {
  @Expose()
  @IsString()
  @IsOptional()
  customerAreaIdentification!: null | string;

  @Expose()
  @IsString()
  @IsOptional()
  parentContractorName!: null | string;

  @Expose()
  @IsArray()
  @IsString({ each: true })
  integrationType!: Array<string>;

  @Expose()
  @IsDateString()
  @IsOptional()
  syncApiFrom!: null | string;

  constructor() {
    this.integrationType = new Array<string>();
  }
}

export class KsefIntegration {
  @Expose()
  @IsOptional()
  @IsEnum(KSEF_INTEGRATION_TYPE_ENUM)
  ksefIntegrationEnum!: KSEF_INTEGRATION_TYPE_ENUM;

  @Expose()
  @IsBoolean()
  fallsUnderElectronicInvoicingPlatform!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  indoorUnitIdentificationNumber!: string;

  @Expose()
  @IsOptional()
  @IsNumber()
  orderNumberFromAttributePrototypeId!: number | null;

  @Expose()
  @IsOptional()
  @IsNumber()
  agreementNumberFromAttributePrototypeId!: number | null;

  @Expose()
  @IsOptional()
  @IsNumber()
  thirdPartyFromAttributePrototypeId!: number | null;

  @Expose()
  @IsOptional()
  @IsString()
  thirdPartyAdditionalValue!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  clientNumber!: string | null;

  @Expose()
  @IsOptional()
  @IsNumber()
  employeeNameFromAttributePrototypeId!: number | null;

  @Expose()
  @IsOptional()
  @IsNumber()
  employeeEmailFromAttributePrototypeId!: number | null;
}
export class ContractorPairCostDocumentSetting {
  @Expose()
  @IsBoolean()
  transferToVatMargin!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  matchingKey!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  positionNameContains!: string | null;

  @Expose()
  @IsBoolean()
  isApprovalRequired!: boolean;

  @Expose()
  @IsBoolean()
  includeFileInReservation!: boolean;
}

export class ContractorExportIntegrationSettingResponse {
  @Expose()
  @Type(() => ContractorExportSetting)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  contractorExportSetting!: ContractorExportSetting;

  @Expose()
  @Type(() => ContractorPairCostDocumentSetting)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  pairCostDocumentSetting!: ContractorPairCostDocumentSetting;

  @Expose()
  @Type(() => ApiIntegration)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  apiIntegration!: ApiIntegration;

  @Expose()
  @Type(() => ExportBetweenOfficeSetting)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  exportBetweenOfficeSetting!: ExportBetweenOfficeSetting;

  @Expose()
  @Type(() => CostDocumentPairSetting)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  costDocumentPairSetting!: CostDocumentPairSetting;

  @Expose()
  @Type(() => SelectItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  integrations!: Array<SelectItem>;

  @Expose()
  @IsArray()
  @IsString({ each: true })
  integrationList!: Array<string>;
}
